import VideoBlock, { VideoBlockProps } from './videoBlock';
import VideoBlockPlaceholder from './videoBlockPlaceholder';
import VideoBlockValue from './videoBlockValue';

export default VideoBlock;
export { VideoBlockPlaceholder, VideoBlockValue };
export type { VideoBlockProps };
